import cytLogo from "../img/cyt-logo.png";
import vwcLogo from "../img/vwc-logo.png";
import logoV from "../img/logo-v.png";

import "./LoaderVWC.css";
import { useTranslation } from "react-i18next";

const LoaderVWC = ({ inline, message, compact }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={`cyt-loader ${inline ? "inline" : ""} `}>
      {compact ? (
        <img src={logoV} alt="Logo" style={{
          width: "50px",
          height: "50px",
          margin: "0 auto",
          display: "block",
        }} />
      ) : (
        <>
          <img src={i18n.language === "nl" ? vwcLogo : cytLogo} alt="Logo" />
          <div className="loader-text">
            {message ? <h4>{message}</h4> : <h4>{t("Laden")}</h4>}
          </div>
        </>
      )}
    </div>
  );
};

export default LoaderVWC;
